// Sales-team check (department matched by name, like the CRM access rule).
// CEO/HR/System_Admin are never treated as Sales even if filed under it.
// UI convenience only - the real block is server-side
// (performance_routes.require_performance_access).
const COMPANY_WIDE_ROLES = ['CEO', 'HR', 'System_Admin'];

export const isSalesMember = (user) =>
  !!user &&
  !COMPANY_WIDE_ROLES.includes(user.role) &&
  ['sales', 'sales department'].includes((user.department || '').trim().toLowerCase());
